import Modal from '../../../components/Modal';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import ControlledInput from '../../../components/ControlledInput';
import { replaceDevice } from '../../../api/api';
import { toast } from 'react-toastify';
import BtnFilled from '../../../components/BtnFilled';
import { ERROR_TEXT } from '../../../constants';
import { useDevicesStore } from '../../../stores';
import { initialConfiguration } from '../constants/constants';
import ControlledDropdown from '../../../components/ControlledDropdown';

const ChangeCounter = ({ showModal, setShowModal, device }) => {
  const methods = useForm({ mode: 'onTouched', defaultValues: { serial_number: '', m_add: '', m_multiplier: 10, manufacturer: 'Meridian' } });
  const { getGroupDevices } = useDevicesStore();

  const inputs = [
    { label: 'Серийный номер', name: 'serial_number', placeholder: 'Введите серийный номер' },
    {
      label: 'Показания при установке в литрах',
      name: 'm_add',
      placeholder: 'Введите показания при установке',
      type: 'number',
    },
    {
      type: 'select',
      label: 'Коэффициент расхода воды',
      name: 'm_multiplier',
      valkey: 'val',
      optkey: 'opt',
      options: initialConfiguration.multiplier,
    },
    {
      label: 'Производитель',
      name: 'manufacturer',
      placeholder: 'Укажите производителя',
    },
  ];

  const generalProps = {
    classContainer: 'mb-4',
    rules: {
      required: {
        value: true,
        message: ERROR_TEXT.REQUIRED,
      },
    },
  };

  const handleSubmit = async (data) => {
    const body = {
      ...data,
      m_add: Number(data?.m_add),
      m_multiplier: Number(data?.m_multiplier),
      old_device_id: device?.id,
      output_type: 'relay',
    };

    await replaceDevice({
      body,
      dataCb: async () => {
        toast.success('Ваши данные успешно обновлены!');
        await getGroupDevices();

        setShowModal(false);
      },
      errCb: (err) => toast.error(`Произошла ошибка при обновлении данных: ${err?.error ?? ''}`),
    });
  };

  return (
    <FormProvider {...methods}>
      <Modal showModal={showModal} closeCb={() => {}} setShowModal={setShowModal} title="Замена счетчика">
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          {inputs.map((input) => {
            if (input.type === 'select') {
              return <ControlledDropdown key={input.name} {...generalProps} {...input} />;
            } else {
              return <ControlledInput key={input.name} {...generalProps} {...input} />;
            }
          })}
          <BtnFilled type={'submit'} title="Cохранить изменения" />
        </form>
      </Modal>
    </FormProvider>
  );
};

export default ChangeCounter;
